module.exports = __webpack_public_path__ + "img/share_tag_01.9424dd70.png";